export default "__VITE_ASSET__3ae697ba__"